import { render, staticRenderFns } from "./CandidatesSelectMenu.vue?vue&type=template&id=aae9a200&lang=pug"
import script from "./CandidatesSelectMenu.vue?vue&type=script&lang=js"
export * from "./CandidatesSelectMenu.vue?vue&type=script&lang=js"
import style0 from "./CandidatesSelectMenu.vue?vue&type=style&index=0&id=aae9a200&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports